//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../../Header";
//Install
import Footer from "../../../Footer";
//Install
import M597I5 from "../../../../Media/Image/030.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Orta Gerilim Tesisleri : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "1998 Yılında İstanbul’da Kurulan Temas Elektrik Taahhüt, Kurulduğu Günden Bu Yana Gösterdiği Başarı ve Süreklilikle Sektörde Tanınan Bir Firma Oldu."
        //Element
        let URL = "https://temaselektrik.com/sunulan-hizmetler/orta-gerilim-tesisleri"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Orta Gerilim Tesisleri"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Orta ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Gerilim "
                                        ),
                                        //Element
                                        "Tesisleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "1998 Yılında İstanbul’da Kurulan Temas Elektrik Taahhüt, Kurulduğu Günden Bu Yana Gösterdiği Başarı ve Süreklilikle Sektörde Tanınan Bir Firma Oldu.",
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "2012 Yılında Faaliyete Geçen Orta Gerilim Departmanımız Kazandığı Deneyim ve Kalite Standartları İle, Orta ve Yüksek Gerilim Tesislerinde Sektörün Güvenilir Çözüm Ortağı Konumuna Geldi."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Trafo Merkezi Kurulumu: Yeni Kurulacak Trafo Tesislerinde, Orta Gerilim Şebeke İrtibat Noktasından Alçak Gerilim Çıkış Panosuna Kadar Tüm Yüksek Gerilim Ekipmanlarının Anahtar Teslimi Kurulum ve Montajı Gerçekleştirilmektedir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "ENH Uygulamaları: 10 kV ile 36 kV Arasındaki Tüm Dağıtım Şebekelerinde, Demir veya Beton Direkler Kullanılarak Yapılan Havai Hat Uygulamaları, Teknik Ekibimiz Tarafından Eksiksiz ve Güvenli Bir Şekilde Tamamlanmaktadır."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Alt Yapı Uygulamaları: Orta ve Alçak Gerilim Altyapıları, Tranşe ve Kablolama İşlemleri İle Yer Altı Şebeke Projeleri, Uluslararası Standartlara Uygun Şekilde Gerçekleştirilmektedir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Gelişen Dünyada Enerji ve Enerji Altyapısının Önemi Giderek Artmaktadır. Akıcı, Kaliteli ve Sürekli Enerji İçin Trafo ve Elektrik Tesislerinin Bakımı Büyük Önem Taşımaktadır."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik; Düzenli Bakım ve Onarımları, Gerekli Teknik Ekipman ve Tecrübeli Ekibi İle Gerçekleştirerek, Enerji Sistemlerinin Güvenilirliğini Garanti Altına Almaktadır."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Trafo Merkezi"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "1. Bina Tipi Trafo Merkezleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "2. Beton Köşk Tipi Trafo Merkezleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "3. Direk Tipi Trafo Merkezleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "4. Yeraltı Köşk Tipi Trafo Merkezleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Trafo Bakım ve Onarım Hizmetleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "1. Trafo Yağı Dielektrik Testi"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "2. Trafo Yağı Filtrasyon İşlemleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "3. İzolasyon Testi"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "4. Termal Kamera İle Isınma Kontrolü"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "5. Kesici ve Ayırıcı Kontrolleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "6. Kumanda Sistemi Testleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "7. Trafo Merkezi Bakım ve Temizliği"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Danışmanlık ve Mühendislik Hizmetleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "1. Yüksek Gerilim İşletme Sorumluluğu"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "2. Resmi ve Teknik Danışmanlık"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB d6p8n6" },
                                        //Element
                                        "3. Müşavirlik Hizmetleri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB x977i0" },
                                        //Element
                                        "4. Projelendirme ve Mühendislik Hizmetleri"
                                    ),
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Orta Gerilim Tesisleri", title: "Orta Gerilim Tesisleri", src: M597I5, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;